// ShimmerPlaylistCard.jsx
export function ShimmerPlaylistCard({ count = 1 }) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="bg-white rounded-lg overflow-hidden shadow-lg flex flex-col lg:flex-row mb-4 animate-pulse"
          style={{ minHeight: 135 }} // Fixe la hauteur proche de la vraie card
        >
          {/* Image shimmer */}
          <div className="w-full lg:w-1/6 bg-[#d0d0e2] p-4 lg:p-6 flex items-center justify-center relative">
            <div className="w-16 h-16 lg:w-20 lg:h-20 rounded-full bg-gray-200" />
          </div>

          <div className="p-4 lg:p-6 flex-1 flex flex-col justify-between">
            {/* Titre */}
            <div className="flex justify-between items-center mb-2">
              <div className="h-5 w-40 bg-gray-200 rounded mb-2" />
              <div className="h-8 w-28 bg-gray-200 rounded" />
            </div>
            {/* Badges */}
            <div className="flex flex-wrap gap-2 mb-4">
              <div className="h-5 w-32 bg-gray-200 rounded" />
              <div className="h-5 w-32 bg-gray-200 rounded" />
              <div className="h-5 w-36 bg-gray-200 rounded" />
            </div>
            {/* Progress bar */}
            <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden mt-3 mb-1">
              <div className="h-2 bg-purple-200 rounded-full shimmer-bar" style={{ width: "60%" }} />
            </div>
            {/* Ligne progression */}
            <div className="flex justify-end">
              <div className="h-4 w-28 bg-gray-200 rounded" />
            </div>
            {/* Bloc catégorie (1 ligne fake) */}
            <div className="mt-4">
              <div className="h-7 w-60 bg-blue-100 rounded mb-2" />
              <div className="h-4 w-44 bg-gray-200 rounded" />
            </div>
          </div>
          {/* Animation shimmer */}
          <style>{`
            .shimmer-bar {
              animation: shimmer-move 1.4s linear infinite;
              background: linear-gradient(110deg, #e0d9f5 8%, #ede9fe 18%, #e0d9f5 33%);
              background-size: 200% 100%;
            }
            @keyframes shimmer-move {
              0% { background-position: -200% 0; }
              100% { background-position: 200% 0; }
            }
          `}</style>
        </div>
      ))}
    </>
  );
}
